import type { AppFeatureDefinition } from "@nasam/kernel";
import { createCommunicationsRoutes } from "./presentation/routes";

const MESSAGING_VIEW = "communications.messaging_management.messaging.view";

export const communicationsFeature: AppFeatureDefinition = {
  id: "communications",
  version: "0.1.0",
  titleKey: "common:businessModules.communications",
  icon: "MessageSquare",
  basePath: "/communications",
  requiredPermissions: [MESSAGING_VIEW],
  navigation: [
    {
      id: "communications",
      titleKey: "common:businessModules.communications",
      icon: "MessageSquare",
      placement: "rail",
      order: 80,
      children: [
        {
          id: "communications-messaging",
          titleKey: "communications:nav.messaging",
          placement: "drawer",
          order: 10,
          path: "/communications/messages",
          requiredPermissions: [MESSAGING_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createCommunicationsRoutes({ context }),
  i18n: {
    namespace: "communications",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "communications",
      labelKey: "communications:permissions.communications",
      children: [
        {
          segment: "messaging_management",
          labelKey: "communications:permissions.messagingManagement",
          children: [
            {
              segment: "messaging",
              labelKey: "communications:permissions.messaging",
              // Irregular: no update grant.
              actions: [
                { id: "view", labelKey: "communications:actions.view" },
                { id: "create", labelKey: "communications:actions.create" },
                { id: "delete", labelKey: "communications:actions.delete" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
